// Runtime code that replaces react/jsx-dev-runtime in the browser.
// Served as a virtual module by the Vite plugin.

const devRuntimeCode = [
  'import * as ReactJSXDevRuntime from "react/jsx-dev-runtime";',
  "",
  "const _jsxDEV = ReactJSXDevRuntime.jsxDEV;",
  "export const Fragment = ReactJSXDevRuntime.Fragment;",
  "",
  // SSR/test guard. Vite SSR, vitest, and Node prerender contexts have no
  // `window` — touching it at module init would crash before any component
  // renders. We still install the wrapper so React's JSX dev runtime stays
  // wired up, but skip the per-element tagging path entirely. Matches
  // lovable-tagger >=1.3.0.
  'const _isBrowser = typeof window !== "undefined";',
  "",
  'const SOURCE_KEY = Symbol.for("__jsxSource__");',
  "",
  "const cleanFileName = (fileName) => {",
  '  if (!fileName) return "";',
  '  if (fileName.includes("dev_server")) {',
  '    fileName = fileName.split("dev_server")[1].slice(1);',
  "  }",
  '  if (fileName.includes("sandbox-scheduler/sandbox")) {',
  '    const sandboxPart = fileName.split("sandbox-scheduler/")[1];',
  '    fileName = sandboxPart.split("/").slice(1).join("/");',
  "  }",
  '  return fileName.replace(/^\\/dev-server\\//, "");',
  "};",
  "",
  "const sourceElementMap = new Map();",
  "if (_isBrowser) {",
  "  window.sourceElementMap = sourceElementMap;",
  "}",
  "",
  "function getSourceKey(sourceInfo) {",
  "  return `${cleanFileName(sourceInfo.fileName)}:${sourceInfo.lineNumber}:${sourceInfo.columnNumber}`;",
  "}",
  "",
  "function unregisterElement(node, sourceInfo) {",
  "  const key = getSourceKey(sourceInfo);",
  "  const refs = sourceElementMap.get(key);",
  "  if (refs) {",
  "    for (const ref of refs) {",
  "      if (ref.deref() === node) {",
  "        refs.delete(ref);",
  "        break;",
  "      }",
  "    }",
  "    if (refs.size === 0) {",
  "      sourceElementMap.delete(key);",
  "    }",
  "  }",
  "}",
  "",
  "function registerElement(node, sourceInfo) {",
  "  const key = getSourceKey(sourceInfo);",
  "  if (!sourceElementMap.has(key)) {",
  "    sourceElementMap.set(key, new Set());",
  "  }",
  "  sourceElementMap.get(key).add(new WeakRef(node));",
  "}",
  "",
  "function getTypeName(type) {",
  '  if (typeof type === "string") return type;',
  '  if (typeof type === "function") return type.displayName || type.name || "Unknown";',
  '  if (typeof type === "object" && type !== null) {',
  '    return type.displayName || type.render?.displayName || type.render?.name || "Unknown";',
  "  }",
  '  return "Unknown";',
  "}",
  "",
  "export function jsxDEV(type, props, key, isStatic, source, self) {",
  "  // During SSR / non-browser execution, skip all tagging and pass",
  "  // through to React untouched. Touching DOM refs or the source map here",
  "  // would crash on Node-only paths (Vite SSR, vitest, etc.).",
  "  if (!_isBrowser) {",
  "    return _jsxDEV(type, props, key, isStatic, source, self);",
  "  }",
  "",
  "  // For custom components (like <Icon />, <Button />), tag their rendered output",
  "  // This captures the JSX element name for library components that don't have source info",
  '  if (source?.fileName && typeof type !== "string" && type !== Fragment) {',
  "    const typeName = getTypeName(type);",
  "    const jsxSourceInfo = {",
  "      fileName: cleanFileName(source.fileName),",
  "      lineNumber: source.lineNumber,",
  "      columnNumber: source.columnNumber,",
  "      displayName: typeName,",
  "    };",
  "",
  "    const originalRef = props?.ref;",
  "    const enhancedProps = {",
  "      ...props,",
  "      ref: (node) => {",
  "        if (node) {",
  "          // Only tag if this element doesn't already have source info",
  "          // (library components won't have it, user components will)",
  "          if (!node[SOURCE_KEY]) {",
  "            node[SOURCE_KEY] = jsxSourceInfo;",
  "            registerElement(node, jsxSourceInfo);",
  "          }",
  "        }",
  '        if (typeof originalRef === "function") {',
  "          originalRef(node);",
  '        } else if (originalRef && typeof originalRef === "object") {',
  "          originalRef.current = node;",
  "        }",
  "      },",
  "    };",
  "",
  "    return _jsxDEV(type, enhancedProps, key, isStatic, source, self);",
  "  }",
  "",
  "  // For host elements (div, span, etc.), tag with component context",
  '  if (source?.fileName && typeof type === "string") {',
  "    const sourceInfo = {",
  "      fileName: cleanFileName(source.fileName),",
  "      lineNumber: source.lineNumber,",
  "      columnNumber: source.columnNumber,",
  "      displayName: type,",
  "    };",
  "",
  "    const originalRef = props?.ref;",
  "",
  "    const enhancedProps = {",
  "      ...props,",
  "      ref: (node) => {",
  "        if (node) {",
  "          const existingSource = node[SOURCE_KEY];",
  "          if (existingSource) {",
  "            if (getSourceKey(existingSource) !== getSourceKey(sourceInfo)) {",
  "              unregisterElement(node, existingSource);",
  "              node[SOURCE_KEY] = sourceInfo;",
  "              registerElement(node, sourceInfo);",
  "            }",
  "          } else {",
  "            node[SOURCE_KEY] = sourceInfo;",
  "            registerElement(node, sourceInfo);",
  "          }",
  "        }",
  '        if (typeof originalRef === "function") {',
  "          originalRef(node);",
  '        } else if (originalRef && typeof originalRef === "object") {',
  "          originalRef.current = node;",
  "        }",
  "      },",
  "    };",
  "    return _jsxDEV(type, enhancedProps, key, isStatic, source, self);",
  "  }",
  "",
  "  return _jsxDEV(type, props, key, isStatic, source, self);",
  "}",
].join("\n");

export default devRuntimeCode;
